/**
 * 實體兌換 api ( storeRedeemAPI ) 可預期的 MESSAGE
 * @typedef {Object} STORE_REDEEM_API_RESPONSE
 * @property {string} REDEEM_EXPIRED - 兌換時間已逾期[406]
 * @property {string} DUPLICATED_REDEMPTION - 獎品已核銷過[422]
 * @property {string} OTHER_ERROR - 其餘後端預期錯誤
 */
export const STORE_REDEEM_API_RESPONSE = {
    REDEEM_EXPIRED: (payload = {}) => payload?.message === 'redeem expired',
    DUPLICATED_REDEMPTION: (payload = {}) => payload?.message === 'duplicated redemption',
    OTHER_ERROR: (payload = {}) => {
        return (
            payload?.message === 'winner not found' || // 400
            payload?.message === 'setting not enabled' || // 400
            payload?.message === 'awardee form' || // 400
            payload?.message === 'condition is invalid' || // 400
            payload?.message === 'Redeem Within Months Last Day is empty' || // 400
            payload?.message === 'Redeem Within Date Time is empty' || // 400
            payload?.message === 'unknown error' || // 400
            payload?.message === 'unknown redeem time type' || // 422
            payload?.message === 'Redeem failed' // 422
        );
    }
};

/**
 * 取得得獎獎品狀態 api ( getPrizeWinnerStatusAPI ) 可預期的 MESSAGE
 * @typedef {Object} GET_PRIZE_WINNER_STATUS_API_RESPONSE
 * @property {string} WINNER_NOT_FOUND - 查無得獎紀錄
 */
export const GET_PRIZE_WINNER_STATUS_API_RESPONSE = {
    WINNER_NOT_FOUND: (payload = {}) => payload?.message === 'winner not found'
};

/**
 * StoreGameResult api ( submitForm / submitPromo ) 可預期的 MESSAGE
 * @typedef {Object} STORE_GAME_RESULT_API_RESPONSE
 * @property {string} ENTRY_FLOW_EXISTS - Entry Flow 已存在
 */
export const STORE_GAME_RESULT_API_RESPONSE = {
    ENTRY_FLOW_EXISTS: (payload = {}) =>
        payload?.message === 'Entry flow exists' && payload?.code === 'ETF-C0-FD0'
};

/**
 * getUserPoints api 可預期的 MESSAGE
 * @typedef {Object} GET_USER_POINTS_API_RESPONSE
 * @property {string} THIRD_PARTY_TIMED_OUT - 對方 api 超過十秒沒有回應 ( cURL error 28 )
 */
export const GET_USER_POINTS_API_RESPONSE = {
    THIRD_PARTY_API_TIMED_OUT: (payload = {}) =>
        payload?.message?.includes('cURL error 28') && payload?.code === 'FVTS-3RD-F0'
};

/**
 * getUserPoints api 可預期的 MESSAGE
 * @typedef {Object} POST_NOTIFY_API_RESPONSE
 * @property {string} NOTIFY_EMAIL_NOT_VALID - member 沒有 email 的時否，無法定月 subtype =2 的通知
 * @see https://app.clickup.com/t/86et0jy7r
 */
export const POST_NOTIFY_API_RESPONSE = {
    MEMBER_NOT_FOUND: (payload = {}) =>
        payload?.message === 'member not found' && payload?.code === 'MB-B0-F0',
    MEMBER_EMAIL_NOT_VALID: (payload = {}) =>
        payload?.message === 'member email not valid' && payload?.code === 'MB-B0-F0',
    DRIVER_NOT_SUPPORT: (payload = {}) =>
        payload?.message === 'driver is not support' && payload?.code === 'NTF-V0-F0',
    CREATE_NOTIFICATION_FAILED: (payload = {}) =>
        payload?.message === 'Create notification failed' && payload?.code === 'NTF-C0-F0',
    MISSING_NOTIFICATION_REQUIRED_FIELDS: (payload = {}) =>
        payload?.message === 'validation failed' && payload?.code === 'CUDF-V0-F0'
};
